<script setup lang="ts">
import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { Bell, BriefcaseBusiness, Building2, ChartNoAxesCombined, ClipboardCheck, FileUser, Gauge, LogOut, Menu, Settings2, ShieldCheck, Users, X } from '@lucide/vue';
import AppLogo from '@/components/AppLogo.vue';
import { authStore } from '@/stores/auth';
const drawer = ref(false); const route=useRoute(); const router=useRouter();
const candidateNav=[{to:'/portal',label:'Beranda',icon:Gauge},{to:'/portal/applications',label:'Lamaran Saya',icon:FileUser},{to:'/portal/assessments',label:'Assessment Profile',icon:ClipboardCheck},{to:'/portal/profile',label:'Profil Saya',icon:Settings2}];
const tenantNav=[{to:'/tenant',label:'Dashboard',icon:Gauge},{to:'/tenant/jobs',label:'Lowongan & Batch',icon:BriefcaseBusiness},{to:'/tenant/pipeline',label:'Pipeline Kandidat',icon:Users},{to:'/tenant/assessments',label:'Assessment & Requirement',icon:ClipboardCheck},{to:'/tenant/team',label:'Hiring Team',icon:ShieldCheck}];
const adminNav=[{to:'/admin',label:'Platform Dashboard',icon:ChartNoAxesCombined},{to:'/admin/tenants',label:'Tenant',icon:Building2},{to:'/admin/integration',label:'Integrasi Psychometric',icon:ClipboardCheck}];
const role=authStore.role;
const nav=computed(()=>role.value==='candidate'?candidateNav:role.value==='platform_admin'?adminNav:tenantNav);
const roleLabel=computed(()=>({candidate:'Kandidat',hiring_team:'Hiring Team',hr:'HR',tenant_admin:'Tenant Admin',platform_admin:'Platform Admin'}[role.value]));
async function logout(){if(authStore.isConfigured)await authStore.signOut();await router.push('/');}
</script>

<template>
  <div class="portal-shell">
    <aside class="sidebar" :class="{ open:drawer }">
      <div class="sidebar-head"><AppLogo inverse /><button class="icon-button mobile-only" @click="drawer=false"><X /></button></div>
      <p class="nav-label">Workspace</p>
      <nav class="sidebar-nav">
        <RouterLink v-for="item in nav" :key="item.to" :to="item.to" :class="{ active:route.path===item.to }" @click="drawer=false"><component :is="item.icon" :size="18" />{{ item.label }}</RouterLink>
      </nav>
      <div class="sidebar-foot"><RouterLink to="/jobs"><BriefcaseBusiness :size="17" /> Jelajahi Lowongan</RouterLink><button @click="logout"><LogOut :size="17" /> Keluar</button></div>
    </aside>
    <section class="portal-main">
      <header class="portal-header">
        <button class="icon-button mobile-only" @click="drawer=true"><Menu /></button>
        <div><strong>{{ route.meta.title || 'RecruitFlow' }}</strong><small>{{ roleLabel }}</small></div>
        <div class="portal-user"><button class="icon-button"><Bell :size="19" /></button><span class="avatar">{{ authStore.displayName.value.split(' ').map(x=>x[0]).join('').slice(0,2) }}</span><div><strong>{{ authStore.displayName.value }}</strong><small>{{ roleLabel }}</small></div></div>
      </header>
      <RouterView />
    </section>
    <div v-if="drawer" class="backdrop" @click="drawer=false"></div>
  </div>
</template>
